import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';
import { Select, MenuItem, FormControl, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

import Button from '../../atoms/button';
import Input from '../../atoms/input';
import ROLES from '../../../constants/roles';
import useWorkspace from '../../../context/WorkspaceContext';

const InviteForm = (props) => {
  // init
  const { users, error, setError, validateEmails, setUsers, existingUsers } = props;
  const { userRoles: roles, setShowUpgradePlan, isFreeTrial, freeUsersLimit } = useWorkspace();

  const handleChange = (index, key, value) => {
    const newUsers = [...users];
    if (validateEmails()) setError('');
    newUsers[index][key] = value;
    setUsers(newUsers);
  };

  const handleAddUser = () => {
    if (isFreeTrial && existingUsers >= freeUsersLimit) return;
    setUsers([...users, { email: '', role: 'employee' }]);
  };

  const handleRemoveUser = (index) => {
    const newUsers = [...users];
    newUsers.splice(index, 1);
    setUsers(newUsers);
  };

  return (
    <div className="invitation-form">
      <div className="invitation-form-title"><strong>Enter Emails</strong></div>
      {users.map((user, index) => (
        <Grid key={`user-${index}`} container spacing={1} alignItems="center">
          <Grid item xs={7}>
            <Input
              value={user.email}
              onChange={(e) => handleChange(index, 'email', e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={3.5}>
            <span className="role-select-box">
              <FormControl size="small" sx={{ minWidth: 130 }}>
                <Select
                  IconComponent={ExpandMoreIcon}
                  className="select-role"
                  defaultValue={ROLES[3].value}
                  onChange={(e) => handleChange(index, 'role', e.target.value)}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {roles.map((role) => (
                    <MenuItem value={role.value} key={role.id} className="select-item">
                      {role.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </span>
          </Grid>
          <Grid item xs={1.5}>
            {index > 0 && (
              <Button primaryDark icon small text onClick={() => handleRemoveUser(index)}>
                <RemoveCircleOutline fontSize="small" />
              </Button>
            )}
          </Grid>
          <Grid item xs={12}>
            {index === users.length - 1 && (
              <>
                <Button className="invitation-form-add-button" text small startIcon={<AddCircleOutline fontSize="small" />} onClick={handleAddUser} disabled={isFreeTrial && existingUsers >= freeUsersLimit}>Add</Button>
                {isFreeTrial && existingUsers >= freeUsersLimit && (
                  <Typography className="invitation-message">
                    Limit reached, maximum {freeUsersLimit} members.
                    <button style={{ border: 'none', backgroundColor: 'white' }} onClick={() => setShowUpgradePlan(true)} type="button" className="blue-text text-underline cursor-pointer">Upgrade to Pro</button>
                  </Typography>
                )}
              </>
            )}
          </Grid>
        </Grid>
      ))}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

InviteForm.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({ email: PropTypes.string, role: PropTypes.string })),
  setUsers: PropTypes.func,
  error: PropTypes.string,
  validateEmails: PropTypes.func,
  setError: PropTypes.func,
  existingUsers: PropTypes.number.isRequired,
};

export default InviteForm;
